import request from '@/utils/request'

const getList = data => {
  return request({
    url: '/mural/item',
    method: 'GET',
    params: data
  })
}

export {
  getList
}



// WEBPACK FOOTER //
// ./src/api/interface/product_info.js